function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { Container, CssContainer } from "../../components/container";
import { PageHeader, Card } from "../../components/analytics-kit";
import { Link } from "react-router-dom";
import { Loader } from "../../components/loaders";
import Error from "../../components/error";
import account from "../../data/account";
import Auth from "../../functions/authenticate";
import { campaignMoneyVisible } from "../../functions/tenant-features";
import { adSvc, parseName, channelLabel, budgetDollars, isActiveStatus, setCampaignName, setCampaignStatus, setCampaignBudget, patchCampaignCaches, rangeQs, DEFAULT_RANGE } from "./common";

/*
 * Full builder-style edit for a LIVE campaign (§ new-edit-flights follow-up).
 * detail.jsx only did budget + pause; this surfaces the whole edit set the
 * worker already supports against the providers: name, budget, status, geo
 * locations (add/remove), audience segments (add/remove), and a new creative.
 * Each section applies independently and enqueues to the campaign worker —
 * the change syncs to Google / Facebook within a few minutes.
 *
 * Money+media gate: managed tenants can't reach this (adBillingMode()); the
 * server also 403s the media endpoints, so the safe direction is default.
 */
const CE_CSS = `
.ce-view .ce-card{background:var(--plk-surface,#fff);border:1px solid var(--plk-border,#e7e2dc);border-radius:12px;padding:18px 20px;margin:14px 0;box-shadow:0 1px 2px rgba(0,0,0,.04)}
.ce-shead{display:flex;gap:11px;align-items:center;margin-bottom:14px}
.ce-num{width:24px;height:24px;border-radius:50%;background:var(--plk-accent,#ff6358);color:#fff;display:grid;place-items:center;font-size:12px;font-weight:700;flex:none}
.ce-stitle{font-weight:700;font-size:14.5px;color:var(--plk-text,#1c1b22)}
.ce-ssub{font-size:12px;color:var(--plk-text-muted,#7d7b88)}
.ce-row2{display:grid;grid-template-columns:1fr 1fr;gap:14px}
@media(max-width:640px){.ce-row2{grid-template-columns:1fr}}
.ce-field{margin-bottom:12px}
.ce-field label{display:block;font-size:12px;font-weight:600;color:var(--plk-text-muted,#7d7b88);margin-bottom:5px}
.ce-input{width:100%;padding:9px 11px;border:1px solid var(--plk-border-strong,#ded7cf);border-radius:8px;background:var(--plk-surface,#fff);color:var(--plk-text,#1c1b22);font-size:14px;font-family:inherit}
.ce-input:focus{outline:none;border-color:var(--plk-accent,#ff6358);box-shadow:0 0 0 3px var(--plk-accent-soft,#ffece9)}
.ce-inline{display:flex;gap:8px;align-items:center}
.ce-inline .ce-input{flex:1}
.ce-actions{display:flex;gap:12px;align-items:center;margin-top:6px}
.ce-note{font-size:12.5px;color:var(--plk-text-muted,#7d7b88)}
.ce-chips{display:flex;flex-wrap:wrap;gap:7px;margin-bottom:12px}
.ce-chip{display:inline-flex;align-items:center;gap:7px;padding:4px 6px 4px 10px;border-radius:16px;background:var(--plk-surface-alt,#f4f1ee);border:1px solid var(--plk-border,#e7e2dc);font-size:12.5px;font-weight:600}
.ce-x{cursor:pointer;width:17px;height:17px;border-radius:50%;background:rgba(0,0,0,.08);display:grid;place-items:center;font-size:13px;line-height:1;color:var(--plk-text-muted,#7d7b88)}
.ce-x:hover{background:var(--plk-accent,#ff6358);color:#fff}
.ce-seglist{border:1px solid var(--plk-border,#e7e2dc);border-radius:10px;margin-top:10px;overflow:hidden}
.ce-seg{display:flex;align-items:center;justify-content:space-between;padding:9px 12px;border-top:1px solid var(--plk-border,#e7e2dc);cursor:pointer}
.ce-seg:first-child{border-top:none}
.ce-seg:hover{background:var(--plk-accent-soft,#ffece9)}
.ce-seg-nm{font-weight:600;font-size:13px}
.ce-seg-meta{font-size:11.5px;color:var(--plk-text-muted,#7d7b88)}
.ce-seg-add{font-size:12px;font-weight:600;color:var(--plk-accent,#e0473c)}
`;
if (typeof document !== "undefined" && !document.getElementById("ce-styles")) {
  const el = document.createElement("style");
  el.id = "ce-styles";
  el.textContent = CE_CSS;
  document.head.appendChild(el);
}
const norm = v => {
  if (!v) return {};
  if (typeof v === "string") {
    try {
      return JSON.parse(v);
    } catch (e) {
      return {};
    }
  }
  return v;
};
class CampaignEditView extends React.Component {
  constructor(p) {
    super(p);
    // ── basics ──
    _defineProperty(this, "saveBasics", async () => {
      const c = this.state.campaign;
      if (!c || this.state.basicsBusy) return;
      const name = (this.state.nameDraft || "").trim();
      const raw = String(this.state.budgetDraft || "").replace(/[$,\s]/g, "");
      const dollars = raw === "" ? 0 : Number(raw);
      if (raw !== "" && !(dollars > 0)) {
        this.setState({
          basicsNote: "Enter the daily budget in dollars, e.g. 50 or 12.50."
        });
        return;
      }
      const current = budgetDollars(c.budget, c.provider);
      const budgetChanged = dollars > 0 && (current == null || Math.abs(dollars - current) >= 0.005);
      // A big jump is almost always a typo; make the person say so.
      if (budgetChanged && current && dollars > current * 3 && !window.confirm(`Raise this campaign's daily budget from $${current.toFixed(2)} to $${dollars.toFixed(2)} a day?`)) return;
      this.setState({
        basicsBusy: true,
        basicsNote: null
      });
      try {
        const ops = [];
        if (name && name !== c.name) ops.push(setCampaignName(this.id(), name));
        if (budgetChanged) ops.push(setCampaignBudget(this.id(), Math.round(dollars * 100) * 10000));
        await Promise.all(ops);
        try {
          patchCampaignCaches(account.get().tenantId, this.id(), {
            name
          });
        } catch (e) {}
        this.setState({
          basicsBusy: false,
          basicsNote: budgetChanged ? `Saved — $${dollars.toFixed(2)}/day queued to the ad platform; the flight's budget follows.` : "Saved."
        });
      } catch (e) {
        this.setState({
          basicsBusy: false,
          basicsNote: this.err(e, "Could not save — try again.")
        });
      }
    });
    _defineProperty(this, "toggleStatus", async () => {
      const c = this.state.campaign;
      if (!c) return;
      const next = isActiveStatus(c.status) ? "Paused" : "Enabled";
      try {
        await setCampaignStatus(this.id(), next);
        this.setState({
          campaign: {
            ...c,
            status: next
          }
        });
      } catch (e) {
        this.setState({
          basicsNote: "Status change could not be queued."
        });
      }
    });
    // ── geo ──
    _defineProperty(this, "applyGeo", async (add, remove) => {
      this.setState({
        geoBusy: true,
        geoNote: null
      });
      try {
        await adSvc(`/campaigns/${this.id()}/locations`).putAsync({
          add,
          remove
        });
        const cur = (this.state._locations || []).filter(z => !remove.includes(z)).concat(add);
        this.setState({
          geoBusy: false,
          addZips: "",
          _locations: cur,
          removedLoc: [],
          geoNote: `${add.length} added · ${remove.length} removed — queued.`
        });
      } catch (e) {
        this.setState({
          geoBusy: false,
          geoNote: this.err(e, "Location update failed.")
        });
      }
    });
    _defineProperty(this, "addGeo", () => {
      const add = (this.state.addZips || "").split(/[\s,]+/).map(z => z.trim()).filter(z => /^\d{5}$/.test(z));
      if (!add.length) {
        this.setState({
          geoNote: "Enter one or more 5-digit ZIPs."
        });
        return;
      }
      this.applyGeo(add, []);
    });
    // ── audiences ──
    _defineProperty(this, "searchSegs", async q => {
      this.setState({
        segQ: q
      });
      if (!q || q.trim().length < 2) {
        this.setState({
          segRows: []
        });
        return;
      }
      this.setState({
        segBusy: true
      });
      try {
        const d = await adSvc(`/audiences/catalog?q=${encodeURIComponent(q.trim())}`).getAsync();
        if (this._alive) this.setState({
          segRows: d && d.segments || [],
          segBusy: false
        });
      } catch (e) {
        if (this._alive) this.setState({
          segBusy: false
        });
      }
    });
    _defineProperty(this, "addAudience", async seg => {
      const gid = String(seg.id || seg.Id || "");
      if (!gid) return;
      this.setState({
        audBusy: true,
        audNote: null
      });
      try {
        await adSvc(`/campaigns/${this.id()}/audiences`).putAsync({
          add: [gid],
          remove: []
        });
        this.setState({
          audBusy: false,
          _audiences: (this.state._audiences || []).concat(gid),
          audNote: `Added "${seg.name || seg.Name || gid}" — queued.`,
          segQ: "",
          segRows: []
        });
      } catch (e) {
        this.setState({
          audBusy: false,
          audNote: this.err(e, "Audience update failed.")
        });
      }
    });
    _defineProperty(this, "removeAudience", async gid => {
      this.setState({
        audBusy: true,
        audNote: null
      });
      try {
        await adSvc(`/campaigns/${this.id()}/audiences`).putAsync({
          add: [],
          remove: [gid]
        });
        this.setState({
          audBusy: false,
          _audiences: (this.state._audiences || []).filter(x => x !== gid),
          audNote: "Removed — queued."
        });
      } catch (e) {
        this.setState({
          audBusy: false,
          audNote: this.err(e, "Audience update failed.")
        });
      }
    });
    // ── creative ──
    _defineProperty(this, "addCreative", async () => {
      const cr = this.state.cr;
      if (!cr.headline.trim() || !cr.finalUrl.trim()) {
        this.setState({
          crNote: "Headline and final URL are required."
        });
        return;
      }
      this.setState({
        crBusy: true,
        crNote: null
      });
      try {
        await adSvc(`/campaigns/${this.id()}/creative`).postAsync({
          creative: cr
        });
        this.setState({
          crBusy: false,
          crNote: "New ad queued — it's added alongside the running one, not swapped in place.",
          cr: {
            headline: "",
            description: "",
            message: "",
            finalUrl: "",
            displayUrl: ""
          }
        });
      } catch (e) {
        this.setState({
          crBusy: false,
          crNote: this.err(e, "Creative add failed.")
        });
      }
    });
    this.state = {
      campaign: null,
      error: false,
      // basics
      nameDraft: "",
      budgetDraft: "",
      basicsBusy: false,
      basicsNote: null,
      // geo
      addZips: "",
      geoBusy: false,
      geoNote: null,
      removedLoc: [],
      // audiences
      segQ: "",
      segRows: [],
      segBusy: false,
      audBusy: false,
      audNote: null,
      addAud: [],
      removedAud: [],
      // creative
      cr: {
        headline: "",
        description: "",
        message: "",
        finalUrl: "",
        displayUrl: ""
      },
      crBusy: false,
      crNote: null
    };
  }
  id() {
    return String(this.props.params.id);
  }
  componentDidMount() {
    this._alive = true;
    this.init();
  }
  componentWillUnmount() {
    this._alive = false;
  }
  async init() {
    if (!campaignMoneyVisible()) {
      this.props.history.replace(`/Campaigns/detail/${this.id()}`);
      return;
    }
    if (!(Auth.isAuthenticated() || (await Auth.attachOrSignIn()))) return;
    try {
      const c = await adSvc(`/campaigns/${this.id()}?${rangeQs(DEFAULT_RANGE)}`).getAsync();
      if (!this._alive) return;
      const t = norm(c && c.targeting);
      this.setState({
        campaign: c,
        nameDraft: c && c.name || "",
        budgetDraft: (() => {
          const d = budgetDollars(c && c.budget, c && c.provider);
          return d == null ? "" : String(Number(d.toFixed(2)));
        })(),
        _locations: (t.locations || t.Locations || []).map(String),
        _audiences: (t.audiences || t.Audiences || []).map(String)
      });
    } catch (e) {
      if (this._alive) this.setState({
        error: true
      });
    }
  }
  err(e, fallback) {
    try {
      const b = JSON.parse(e.message);
      if (b.error) return b.error;
    } catch (x) {}
    return fallback;
  }
  render() {
    const s = this.state;
    if (s.error) return /*#__PURE__*/React.createElement(Error, {
      onRetry: () => this.setState({
        error: false
      }, this.init)
    });
    if (!s.campaign) return /*#__PURE__*/React.createElement(Loader, null);
    const c = s.campaign;
    const p = parseName(c.name || "");
    const active = isActiveStatus(c.status);
    const sectionHead = (n, title, sub) => /*#__PURE__*/React.createElement("div", {
      className: "ce-shead"
    }, /*#__PURE__*/React.createElement("span", {
      className: "ce-num"
    }, n), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "ce-stitle"
    }, title), /*#__PURE__*/React.createElement("div", {
      className: "ce-ssub"
    }, sub)));
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view wa-view campaigns-view ce-view"
    }, /*#__PURE__*/React.createElement(PageHeader, {
      crumbs: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
        to: "/Campaigns"
      }, "Campaigns"), " \xB7 ", /*#__PURE__*/React.createElement(Link, {
        to: "/Campaigns/Flights"
      }, "Flights"), " \xB7 ", /*#__PURE__*/React.createElement(Link, {
        to: `/Campaigns/detail/${this.id()}`
      }, p.flight || c.name), " \xB7 Edit"),
      title: `Edit campaign${p.market ? `: ${p.market}` : ""}`,
      subtitle: `Each section applies on its own and syncs to ${channelLabel(p.channel) && channelLabel(p.channel) !== "—" ? channelLabel(p.channel) : "the ad platform"} within a few minutes. Creative additions ramp a new ad rather than replace the running one.`,
      chips: [{
        k: "Status",
        v: c.status
      }],
      actions: /*#__PURE__*/React.createElement("button", {
        className: `k-button k-button-md k-rounded-md k-button-solid ${active ? "k-button-solid-base" : "k-button-solid-primary"}`,
        onClick: this.toggleStatus
      }, active ? "Pause campaign" : "Resume campaign")
    }), /*#__PURE__*/React.createElement(Card, {
      title: ""
    }, /*#__PURE__*/React.createElement("div", {
      className: "ce-card"
    }, sectionHead(1, "Basics", "Name and daily budget"), /*#__PURE__*/React.createElement("div", {
      className: "ce-row2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ce-field"
    }, /*#__PURE__*/React.createElement("label", null, "Campaign name"), /*#__PURE__*/React.createElement("input", {
      className: "ce-input",
      value: s.nameDraft,
      onChange: e => this.setState({
        nameDraft: e.target.value
      })
    })), /*#__PURE__*/React.createElement("div", {
      className: "ce-field"
    }, /*#__PURE__*/React.createElement("label", null, "Daily budget (USD)"), /*#__PURE__*/React.createElement("input", {
      className: "ce-input",
      value: s.budgetDraft,
      onChange: e => this.setState({
        budgetDraft: e.target.value
      }),
      placeholder: "6.00"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "ce-actions"
    }, /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-sm k-rounded-md k-button-solid k-button-solid-primary",
      disabled: s.basicsBusy,
      onClick: this.saveBasics
    }, s.basicsBusy ? "Saving…" : "Save basics"), s.basicsNote && /*#__PURE__*/React.createElement("span", {
      className: "ce-note"
    }, s.basicsNote))), /*#__PURE__*/React.createElement("div", {
      className: "ce-card"
    }, sectionHead(2, "Geo targeting", "Add or remove ZIP targets"), (s._locations || []).length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "ce-chips"
    }, s._locations.map(z => /*#__PURE__*/React.createElement("span", {
      key: z,
      className: "ce-chip"
    }, z, /*#__PURE__*/React.createElement("span", {
      className: "ce-x",
      title: "Remove",
      onClick: () => this.applyGeo([], [z])
    }, "\xD7")))), /*#__PURE__*/React.createElement("div", {
      className: "ce-inline"
    }, /*#__PURE__*/React.createElement("input", {
      className: "ce-input",
      value: s.addZips,
      onChange: e => this.setState({
        addZips: e.target.value
      }),
      placeholder: "Add ZIPs \u2014 e.g. 33487, 34236, 34102"
    }), /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-sm k-rounded-md k-button-solid k-button-solid-base",
      disabled: s.geoBusy,
      onClick: this.addGeo
    }, s.geoBusy ? "…" : "Add")), s.geoNote && /*#__PURE__*/React.createElement("span", {
      className: "ce-note"
    }, s.geoNote)), /*#__PURE__*/React.createElement("div", {
      className: "ce-card"
    }, sectionHead(3, "Audiences", "Search Google + Meta segments"), (s._audiences || []).length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "ce-chips"
    }, s._audiences.map(a => /*#__PURE__*/React.createElement("span", {
      key: a,
      className: "ce-chip"
    }, a, /*#__PURE__*/React.createElement("span", {
      className: "ce-x",
      onClick: () => this.removeAudience(a)
    }, "\xD7")))), /*#__PURE__*/React.createElement("div", {
      className: "ce-inline"
    }, /*#__PURE__*/React.createElement("input", {
      className: "ce-input",
      value: s.segQ,
      onChange: e => this.searchSegs(e.target.value),
      placeholder: "Search segments \u2014 \"interior design\", \"luxury home\"\u2026"
    })), s.segBusy && /*#__PURE__*/React.createElement("span", {
      className: "ce-note"
    }, "Searching\u2026"), s.segRows.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "ce-seglist"
    }, s.segRows.slice(0, 8).map((seg, i) => /*#__PURE__*/React.createElement("div", {
      key: seg.id || seg.Id || i,
      className: "ce-seg",
      onClick: () => !s.audBusy && this.addAudience(seg)
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "ce-seg-nm"
    }, seg.name || seg.Name), /*#__PURE__*/React.createElement("div", {
      className: "ce-seg-meta"
    }, seg.kind || seg.Kind || "segment", seg.provider ? " · " + seg.provider : "")), /*#__PURE__*/React.createElement("span", {
      className: "ce-seg-add"
    }, "+ add")))), s.audNote && /*#__PURE__*/React.createElement("span", {
      className: "ce-note"
    }, s.audNote)), /*#__PURE__*/React.createElement("div", {
      className: "ce-card"
    }, sectionHead(4, "Creative", "Add a new ad to this campaign"), /*#__PURE__*/React.createElement("div", {
      className: "ce-row2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ce-field"
    }, /*#__PURE__*/React.createElement("label", null, "Headline"), /*#__PURE__*/React.createElement("input", {
      className: "ce-input",
      value: s.cr.headline,
      onChange: e => this.setState({
        cr: {
          ...s.cr,
          headline: e.target.value
        }
      })
    })), /*#__PURE__*/React.createElement("div", {
      className: "ce-field"
    }, /*#__PURE__*/React.createElement("label", null, "Final URL"), /*#__PURE__*/React.createElement("input", {
      className: "ce-input",
      value: s.cr.finalUrl,
      onChange: e => this.setState({
        cr: {
          ...s.cr,
          finalUrl: e.target.value
        }
      }),
      placeholder: "https://\u2026"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "ce-row2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ce-field"
    }, /*#__PURE__*/React.createElement("label", null, "Description"), /*#__PURE__*/React.createElement("input", {
      className: "ce-input",
      value: s.cr.description,
      onChange: e => this.setState({
        cr: {
          ...s.cr,
          description: e.target.value
        }
      })
    })), /*#__PURE__*/React.createElement("div", {
      className: "ce-field"
    }, /*#__PURE__*/React.createElement("label", null, "Display URL"), /*#__PURE__*/React.createElement("input", {
      className: "ce-input",
      value: s.cr.displayUrl,
      onChange: e => this.setState({
        cr: {
          ...s.cr,
          displayUrl: e.target.value
        }
      })
    }))), /*#__PURE__*/React.createElement("div", {
      className: "ce-field"
    }, /*#__PURE__*/React.createElement("label", null, "Primary text"), /*#__PURE__*/React.createElement("input", {
      className: "ce-input",
      value: s.cr.message,
      onChange: e => this.setState({
        cr: {
          ...s.cr,
          message: e.target.value
        }
      })
    })), /*#__PURE__*/React.createElement("div", {
      className: "ce-actions"
    }, /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-sm k-rounded-md k-button-solid k-button-solid-primary",
      disabled: s.crBusy,
      onClick: this.addCreative
    }, s.crBusy ? "Adding…" : "Add creative"), s.crNote && /*#__PURE__*/React.createElement("span", {
      className: "ce-note"
    }, s.crNote)))));
  }
}
export default withRouter(CampaignEditView);